import { render } from "./WCookie.vue?vue&type=template&id=da15fa52"
import script from "./WCookie.vue?vue&type=script&lang=js"
export * from "./WCookie.vue?vue&type=script&lang=js"

import exportComponent from "../../../.yarn/__virtual__/vue-loader-virtual-6763a87ef6/0/cache/vue-loader-npm-17.4.2-00674d01e5-ffbe3e848e.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__